






































import { mapState } from "vuex";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import TheH01ProfilePanel from "@/general/components/pages/parts/PointHistoryList/TheH01ProfilePanel.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconHistory from "@/common/components/icons/IconHistory.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    CommonHeading,
    TheH01ProfilePanel,
    IconBase,
    IconHistory,
    ButtonMain,
    TheBreadcrumb
  }
})
export default class NoPointHistory extends Vue {
  unit = commons.OrgPageSpecific?.point_name;
  isSp: any = globals.isSpScreenWidth;
  breadcrumb: any = [];

  $refs!: {
    theHeader: TheHeader;
  };

  get iconSize() {
    const resultIconSize: any = {
      true: {
        width: 53,
        height: 47
      },

      false: {
        width: 78,
        height: 69
      }
    };

    return resultIconSize[this.isSp];
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  data() {
    return {
      refine: {
        target: "all",
        shownState: false
      },
      sorted: false,
      search: ""
    };
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");
    const orderingParam = urlParams.get("ordering")
      ? (urlParams.get("ordering") as string)
      : "";
    const filterParam = urlParams.get("transaction_type")
      ? (urlParams.get("transaction_type") as string)
      : "";
    const filterThanksParam = urlParams.get("transaction_direction")
      ? (urlParams.get("transaction_direction") as string)
      : "";
    const searchParam = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";
    const filter_position = parseInt(
      urlParams.get("filter_position") as string
    );
    const refine_position = parseInt(
      urlParams.get("refine_position") as string
    );

    const breadcrumb = [
      {
        text: "",
        url: "/home/",
        pageType: "home"
      },
      {
        text: " ポイント確認",
        url: "",
        pageType: "lower"
      }
    ];

    await commons.getBreadcrumb(breadcrumb);
  }
}
